var map = {
	"./fonts/GearsOfPeace.ttf": 8785,
	"./fonts/TheFont.css": 1740,
	"./image/1.png": 257,
	"./image/2.png": 9674,
	"./image/3.png": 4883,
	"./image/4.jpg": 3208,
	"./image/5.jpg": 3877,
	"./image/gongzhonghao.jpg": 4565,
	"./image/logo.png": 8239,
	"./image/snail_logo.png": 1481,
	"./image/枪式.png": 6415,
	"./image/激光云台.png": 7888,
	"./vedio/beijingvedio.mp4": 7979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;